<template>
  <div class="home">
    <div class="columns">
      <div class="column">
        <h2>אפיליאייטס</h2>
      </div>
      <div class="column has-text-left">
        <router-link :to="{name: 'home'}"
        class="nav-btn button">חזור לניהול מנויים</router-link>
      </div>
    </div>
    <new-ref></new-ref>
    <ref-list></ref-list>
  </div>
</template>

<script>
import RefList from "@/components/refs/RefList";
import NewRef from "@/components/refs/NewRef";

export default {
  components: {
    RefList,
    NewRef
  },
  methods: {
    getRefList() {
      this.$store.dispatch("getRefList");
    }
  },

  created() {
    this.getRefList();
  }
};
</script>

<style>
</style>
